var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4279",
    "data-name": "Caminho 4279",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4280",
    "data-name": "Caminho 4280",
    d: "M20.01,15.38a11.443,11.443,0,0,1-3.53-.56.977.977,0,0,0-1.01.24L13.9,17.03A15.183,15.183,0,0,1,7.01,10.2L8.96,8.54A1.021,1.021,0,0,0,9.2,7.52a11.153,11.153,0,0,1-.56-3.53A1,1,0,0,0,7.65,3H4.19C3.65,3,3,3.24,3,3.99A17.152,17.152,0,0,0,20.01,21,1.049,1.049,0,0,0,21,19.82V16.37a1,1,0,0,0-.99-.99Z",
    fill: "#4b4b4b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon_call.0e671b9a.svg";
export { ForwardRef as ReactComponent };